import { NgModule } from '@angular/core';
import {PreloadAllModules, Routes, RouterModule, NoPreloading } from '@angular/router';
import { LinkExpiredComponent } from './link-expired/link-expired.component';

/**
 * importing Modules
 */
const accountModule = () => import('./account/account.module').then(x => x.AccountModule);
const baseModule = () => import('./base/base.module').then(x => x.BaseModule);
const publicModule = () => import('./public/public.module').then(x => x.PublicModule);

const routes: Routes = [
    { path: 'public', loadChildren: publicModule }, // lazy loading public module
    { path: 'account', loadChildren: accountModule }, // lazy loading account module
    { path: 'link-expired', component: LinkExpiredComponent },
    { path: '', loadChildren: baseModule },
    // otherwise redirect to credit-union..
    { path: '**', redirectTo: 'credit-union-list' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }